import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
// -
import {MiniQ2AdvancedValuesModel, MiniQ2HasAdvancedModel} from "./models/MiniQ2AdvancedModels";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import RowTRComponent from "../../../components/RowTRComponent";


const MiniQ2AdvancedForm = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MiniQ2AdvancedValuesModel});
    const [has, setHas] = useState({...MiniQ2HasAdvancedModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...MiniQ2AdvancedValuesModel});
            setHas({...MiniQ2HasAdvancedModel});
        }
    }, [item]);

    const onChangeSelect = (e) => {
        let {name, value} = e.target;
        let values_ = {...values};
        values_[name] = value;
        setValues({...values_});
    }

    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{_TC("protocol")}</td>
                        <td>{_TC("protocol.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">{_TC("protocol")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="protocol"
                                        name="protocol"
                                        value={values.protocol}
                                        title={_TC("protocol")}
                                        onChange={onChangeSelect}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="MQTT">MQTT</option>
                                        <option value="MQTTS">MQTTS</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <tr>
                        <td>{_TC("type_topic")}</td>
                        <td>{_TC("type_topic.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">{_TC("type_topic")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="type_topic"
                                        name="type_topic"
                                        value={values.type_topic}
                                        title="Topic"
                                        onChange={onChangeSelect}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="data">{_TC("topic_data")}</option>
                                        <option value="alerts">{_TC("topic_alerts")}</option>
                                        <option value="control">{_TC("topic_control")}</option>
                                        <option value="admin">{_TC("topic_admin")}</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <RowTRComponent
                        fieldName="ip"
                        _TC={_TC}
                        valueIn={values.ip}
                        hasIn={has.has_ip}
                        deactivated={MiniQ2AdvancedValuesModel.ip}
                        styleCenterMiddle={styleCenterMiddle}

                    />
                    <RowTRComponent
                        fieldName={"port"}
                        _TC={_TC}
                        valueIn={values.port}
                        hasIn={has.has_port}
                        deactivated={MiniQ2AdvancedValuesModel.port}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"user"}
                        _TC={_TC}
                        valueIn={values.user}
                        hasIn={has.has_user}
                        deactivated={MiniQ2AdvancedValuesModel.user}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"pass"}
                        _TC={_TC}
                        valueIn={values.pass}
                        hasIn={has.has_pass}
                        deactivated={MiniQ2AdvancedValuesModel.pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic"}
                        _TC={_TC}
                        valueIn={values.topic}
                        hasIn={has.has_topic}
                        deactivated={MiniQ2AdvancedValuesModel.topic}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default MiniQ2AdvancedForm